export const reducer = (state, action) => ({ ...state, [action.name]: action.data })
